import React from 'react'
import axios from 'axios'
import {MainLimitBar, MainFeedConfiguration,MainStackBlock} from './index'

class MainConfigurationBar extends React.Component{
    constructor(){
        super()
        this.state = {
            modules:[],
            initData:false,
        }
    }

    componentDidMount(){
        axios.get('/api/index/recommend_list')
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({modules: res.data.data.modules,initData:true})
                }
            }).catch((error) => {
            console.log(error)
        })
    }

    render(){
        return this.state.initData ? (
            <div>
                {this.state.modules.length>0 && this.state.modules.map((item, index) => {
                    switch (item.module_style){
                        case '1':
                            return <MainLimitBar data={item} key={index}/>
                        case '2':
                            return <MainFeedConfiguration data={item} key={index}/>
                        case '3':
                            return <MainFeedConfiguration data={item} key={index}/>
                        case '4':
                            return <MainStackBlock data={item} key={index}/>
                        default:
                            return ''
                    }
                })}
            </div>
        ) : null
    }
}

export default  MainConfigurationBar


// WEBPACK FOOTER //
// ./src/components/main/MainConfigurationBar.js